module.exports = __webpack_public_path__ + "img/girl-workout.18bd20fc.jpg";